import { CHANNELS_CONVERSATION_MODE } from 'src/components/Stores/constants/conversationChannels';

interface TConversationModeArea {
    conversationMode?: string;
}

/**
 * Whether a store area sends through its `conversationChannels` (OmniChannel)
 * instead of the legacy area fields.
 */
export const isChannelsModeArea = (
    area: TConversationModeArea | null | undefined
): boolean => area?.conversationMode === CHANNELS_CONVERSATION_MODE;
